import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

export const DraggableWidget = ({ id, children, disabled = false }: any) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data: { from: "library" },
    disabled: disabled,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    // transition: transform ? "250ms ease" : undefined,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...(!disabled ? listeners : {})}
      {...(!disabled ? attributes : {})}
      className={`relative z-10 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {children}
    </div>
  );
};
